<div class="shape-item-container gap-2" fxLayout="column">
  <nw-shape-item
    *ngFor="let shape of shapes$ | async"
    [shape]="shape"
  ></nw-shape-item>

  <div
    class="fs-11 italic"
    style="margin: 4px auto; opacity: 0.6"
    *ngIf="(shapes$ | async)?.length === 0"
  >
    No shapes yet
  </div>
</div>
